import client from './client';

// Bảng lương cá nhân của chính mình.
export const getMyPayslip = (month) => client.get('/payroll/mine', { params: { month } }).then((r) => r.data);

// Bảng lương tổng hợp theo tháng + phòng ban (kế toán trưởng / GĐ).
export const listPayroll = (month, department) =>
  client.get('/payroll', { params: { month, department } }).then((r) => r.data);

export const savePayrollRow = (userId, month, body) =>
  client.put(`/payroll/${userId}`, body, { params: { month } }).then((r) => r.data);

export const allocateOverQuota = (month, department, total) =>
  client.post('/payroll/allocate', { total }, { params: { month, department } }).then((r) => r.data);

export const lockPayroll = (month, department, unlock = false) =>
  client.post('/payroll/lock', { unlock }, { params: { month, department } }).then((r) => r.data);

// Chốt lương 1 CÁ NHÂN + gửi thông báo cho nhân viên đó.
export const lockPayrollUser = (month, userId, unlock = false) =>
  client.post('/payroll/lock-user', { month, userId, unlock }).then((r) => r.data);

// Quét doanh thu để tính lương (thường + hỗ trợ + VIP) theo tháng — chạy nền.
export const scanPayrollMonth = (month) => client.post('/payroll-scan', null, { params: { month } }).then((r) => r.data);
export const payrollScanStatus = (month) => client.get('/payroll-scan', { params: { month } }).then((r) => r.data);
